export default {

    LOAD_GROUPS(state, group) {
        state.items = group;
    }

}